import React from 'react';

import { Box, Typography } from '@mui/material';

import type { StepItem } from 'src/components/common';
import { Stepper } from 'src/components/common';

export const StepperSection: React.FC = () => {
  return (
    <Box component="section">
      <Typography variant="h3">Stepper</Typography>

      <Box mt={2}>
        <Stepper steps={steps} activeStepKey="1" />
      </Box>
    </Box>
  );
};

const steps: StepItem[] = [
  { key: '1', label: 'New Request' },
  { key: '2', label: 'Declined by Employee', error: true },
  { key: '3', label: 'Reviewed by Verifier' },
];
